(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layering-explorer__section"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Scroll a layer section to just below the sticky nav, re-correcting until it
     settles. Two things make a single scroll unreliable here:
       1. The step/beyond wrappers use content-visibility:auto with an 800px
          contain-intrinsic-size estimate, so sections between the explorer (top of
          page) and the target are unrendered placeholders — the first scroll aims at
          an estimated position and lands short. Each scroll renders the sections it
          passes (their real height is then remembered), so we re-scroll until the
          offset stops moving — capped so a no-op or aligned target exits immediately.
       2. The page's scroll-padding-top is set (inline, by JS) to the FIXED header
          height, but that header hides on scroll-down — at rest only the ~52px sticky
          layering nav is pinned. Anchoring via scroll-padding/scroll-margin would land
          the section with a large gap below the nav, so we scroll to a manual offset
          measured from the sticky nav instead, independent of the header height.
     The runToken guards against overlapping runs from rapid clicks. */
  var scrollRunToken = 0;

  function smoothScrollToLayer(target) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reduceMotion ? 'auto' : 'smooth';
    var token = ++scrollRunToken;
    var maxTries = 10;
    var tries = 0;
    var lastY = null;

    function scrollToTarget() {
      var nav = document.querySelector('.layering-nav');
      var offset = (nav ? nav.getBoundingClientRect().height : 52) + 24; // clear the nav + a small gap
      var y = Math.round(window.scrollY + target.getBoundingClientRect().top - offset);
      window.scrollTo({ top: Math.max(0, y), behavior: behavior });
    }

    function settled() {
      if (token !== scrollRunToken) return; // superseded by a newer run
      var y = Math.round(window.scrollY);
      tries++;
      var stable = lastY !== null && Math.abs(y - lastY) <= 2;
      lastY = y;
      if (stable || tries >= maxTries) return;
      scrollToTarget();
      schedule();
    }

    function schedule() {
      var fired = false;
      var timer;
      function fire() {
        if (fired) return;
        fired = true;
        window.removeEventListener('scrollend', fire);
        clearTimeout(timer);
        // Let any content-visibility section revealed by this scroll lay out before re-checking.
        requestAnimationFrame(function () { requestAnimationFrame(settled); });
      }
      // scrollend fires after a real scroll; the timeout covers a no-op scroll
      // (already aligned) where scrollend never fires.
      window.addEventListener('scrollend', fire, { once: true });
      timer = setTimeout(fire, 400);
    }

    scrollToTarget();
    schedule();
  }

  function initLayeringExplorer(sectionEl) {
    if (!sectionEl) return;

    var container = sectionEl.querySelector('[id^="layering-explorer-"]');
    if (!container) return;

    var markers = Array.prototype.slice.call(
      container.querySelectorAll('.layering-explorer__marker')
    );
    if (!markers.length) return;

    function closeAll() {
      markers.forEach(function (m) {
        m.classList.remove('is-open');
        m.setAttribute('aria-expanded', 'false');
        var boxId = m.getAttribute('aria-controls');
        if (boxId) {
          var box = container.querySelector('#' + boxId);
          if (box) {
            box.classList.remove('is-open');
            box.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }

    function openMarker(marker) {
      marker.classList.add('is-open');
      marker.setAttribute('aria-expanded', 'true');
      var boxId = marker.getAttribute('aria-controls');
      if (boxId) {
        var box = container.querySelector('#' + boxId);
        if (box) {
          box.classList.add('is-open');
          box.setAttribute('aria-hidden', 'false');
        }
      }
      /* Smooth-scroll the explorer into view so the image and its info box are
         fully visible when a hotspot is opened (no scroll lock). */
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      container.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }

    markers.forEach(function (marker) {
      marker.addEventListener('click', function () {
        var isOpen = marker.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          openMarker(marker);
        }
      });
    });

    // Close via the box's × button (reachable even when the box covers a marker)
    Array.prototype.slice.call(
      container.querySelectorAll('.layering-explorer__box-close')
    ).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeAll();
      });
    });

    // "DISCOVER MORE" CTAs: when the link points at a section on THIS page
    // (e.g. /pages/layering#base-layers or #base-layers), close the box and
    // smooth-scroll to it instead of doing a full navigation. Off-page links are
    // left untouched. Mirrors the sticky nav's scroll behaviour (the target step's
    // scroll-margin-top clears the sticky nav).
    Array.prototype.slice.call(
      container.querySelectorAll('.layering-explorer__box-cta')
    ).forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        var href = cta.getAttribute('href');
        if (!href) return;
        var url;
        try {
          url = new URL(href, window.location.href);
        } catch (err) {
          return;
        }
        // Only intercept same-page hash links whose target actually exists.
        if (!url.hash || url.pathname !== window.location.pathname) return;
        var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (!target) return;
        e.preventDefault();
        closeAll();
        smoothScrollToLayer(target);
      });
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll();
      }
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      var isInsideMarker = markers.some(function (m) {
        return m.contains(e.target);
      });
      var boxes = Array.prototype.slice.call(
        container.querySelectorAll('.layering-explorer__box')
      );
      var isInsideBox = boxes.some(function (b) {
        return b.contains(e.target);
      });
      if (!isInsideMarker && !isInsideBox) {
        closeAll();
      }
    });
  }

  // Init on page load
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll(
      '.layering-explorer__wrapper'
    );
    sections.forEach(function (wrapper) {
      initLayeringExplorer(wrapper);
    });
  });

  // Re-init on theme editor section load/unload
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target;
    if (
      sectionEl &&
      sectionEl.querySelector('.layering-explorer__wrapper')
    ) {
      initLayeringExplorer(
        sectionEl.querySelector('.layering-explorer__wrapper')
      );
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layering-nav__section"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initLayeringNav(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('.layering-nav__link'));
    if (!links.length) return;

    // Smooth-scroll on click
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var anchor = link.getAttribute('data-anchor');
        if (!anchor) return;
        var target = document.getElementById(anchor);
        if (target) {
          e.preventDefault();
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
    });

    // Active-state via IntersectionObserver
    if (!('IntersectionObserver' in window)) return;

    var anchorEls = [];
    links.forEach(function (link) {
      var anchor = link.getAttribute('data-anchor');
      if (!anchor) return;
      var el = document.getElementById(anchor);
      if (el) anchorEls.push({ el: el, link: link });
    });
    if (!anchorEls.length) return;

    var activeLink = links[0];
    activeLink.classList.add('is-active');
    activeLink.setAttribute('aria-current', 'true');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var pair = anchorEls.find(function (p) { return p.el === entry.target; });
          if (!pair) return;
          if (entry.isIntersecting) {
            if (activeLink) {
              activeLink.classList.remove('is-active');
              activeLink.removeAttribute('aria-current');
            }
            activeLink = pair.link;
            activeLink.classList.add('is-active');
            activeLink.setAttribute('aria-current', 'true');
          }
        });
      },
      { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
    );

    anchorEls.forEach(function (pair) {
      observer.observe(pair.el);
    });

    // Clean up when the section is removed/reloaded in the theme editor
    root.addEventListener('shopify:section:unload', function () {
      observer.disconnect();
    });
  }

  /* Keep the sticky nav glued to the bottom edge of the global header so it sits
     BELOW the menu when the header is visible and rises to the top when the header
     hides on scroll — matching the PLP filter-bar behaviour (header-animation.js
     animates the header; we just track its rendered bottom each frame). */
  var headerFollowStarted = false;
  function followHeader() {
    if (headerFollowStarted) return;
    var header = document.querySelector('.header__container');
    var nav = document.querySelector('.layering-nav');
    var wrapper = nav ? nav.closest('[id^="shopify-section-"]') : null;
    if (!header || !wrapper) return;
    headerFollowStarted = true;
    var last = -1;

    /* The header is position:fixed at top:0 and header-animation.js moves it with a
       GSAP translateY. We track its bottom edge each frame to glue the sticky nav to
       it. Calling getBoundingClientRect() every frame forces a SYNCHRONOUS layout on
       each frame — on this long, card-heavy page that is a dominant scroll-jank cost,
       interleaving with third-party scripts' own reflows. Instead we read GSAP's
       cached transform value (no layout) and add the header height (measured off the
       hot path), falling back to a bounding-rect read only if GSAP isn't present. */
    var headerHeight = header.offsetHeight || 0;
    window.addEventListener('resize', function () {
      headerHeight = header.offsetHeight || 0;
    }, { passive: true });

    var hasGsap = !!(window.gsap && typeof window.gsap.getProperty === 'function');

    function currentBottom() {
      if (hasGsap) {
        var y = parseFloat(window.gsap.getProperty(header, 'y')) || 0;
        var bottom = headerHeight + y;
        return bottom < 0 ? 0 : bottom;
      }
      var rect = header.getBoundingClientRect().bottom;
      return rect < 0 ? 0 : rect;
    }

    function tick() {
      var rounded = Math.round(currentBottom());
      if (rounded !== last) {
        wrapper.style.top = rounded + 'px';
        last = rounded;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* Solid header once scrolled PAST the hero — the global header is transparent
     site-wide on this page (header-white, no permanent-white gradient). Over the
     full-bleed hero it must stay transparent/white (per design); only once the hero
     has scrolled behind it and real page content sits under the bar do we paint a
     solid light bar with dark icons (matching the standard pages). The threshold is
     the hero's bottom minus the header height, measured off the scroll hot path. */
  function initSolidHeader() {
    /* This section script is served on every storefront page, so bail out unless
       this is actually the Layering page (the sticky nav is present). */
    if (!document.querySelector('.layering-nav')) return;

    var header = document.querySelector('.header__container');
    var heroInner = document.querySelector('[class*="hero-banner-multiple"]');
    var heroSection = heroInner ? heroInner.closest('[id^="shopify-section-"]') : null;

    function computeThreshold() {
      var hh = header ? header.offsetHeight : 80;
      if (heroSection) {
        return Math.max(0, heroSection.offsetTop + heroSection.offsetHeight - hh);
      }
      // Fallback: the hero is full-viewport, so ~one screen minus the header.
      return Math.max(0, window.innerHeight - hh);
    }

    var threshold = computeThreshold();
    window.addEventListener('resize', function () { threshold = computeThreshold(); }, { passive: true });
    window.addEventListener('load', function () { threshold = computeThreshold(); });

    var last = null;
    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var solid = y > threshold;
      if (solid !== last) {
        document.body.classList.toggle('layering-header-solid', solid);
        last = solid;
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function init() {
    var navRoots = Array.prototype.slice.call(document.querySelectorAll('.layering-nav'));
    navRoots.forEach(function (root) {
      initLayeringNav(root);
    });
    followHeader();
    initSolidHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when this section (or a target step) is reloaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.layering-nav');
    if (root) initLayeringNav(root);
  });

  // Drop the solid-header body flag if the nav section is removed in the editor,
  // so the global header isn't left stranded in the solid state.
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector('.layering-nav')) {
      document.body.classList.remove('layering-header-solid');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layering-products-slider__section"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var INIT_ATTR = 'data-layering-embla-init';

  function parseBoolean(value) {
    if (value === undefined || value === null || value === '') return null;
    var normalized = String(value).toLowerCase();
    if (['true', '1', 'yes', 'on'].indexOf(normalized) !== -1) return true;
    if (['false', '0', 'no', 'off', 'none', 'hide'].indexOf(normalized) !== -1) return false;
    return null;
  }

  function applySlideSizing(container, slides) {
    if (!container || !slides || !slides.length) return null;
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var slidesDesktop = parseFloat(container.dataset.emblaSlidesDesktop || '');
    var slidesMobile  = parseFloat(container.dataset.emblaSlidesMobile  || '');
    var perView = isMobile ? slidesMobile : slidesDesktop;
    if (!perView || Number.isNaN(perView)) {
      container.style.removeProperty('--embla-slide-size');
      slides.forEach(function (slide) {
        slide.style.flex = '';
        slide.style.width = '';
        slide.style.maxWidth = '';
      });
      return null;
    }
    var size = (100 / perView) + '%';
    container.style.setProperty('--embla-slide-size', size);
    slides.forEach(function (slide) {
      slide.style.flex     = '0 0 ' + size;
      slide.style.width    = size;
      slide.style.maxWidth = size;
    });
    return perView;
  }

  function initSection(root) {
    if (typeof window.EmblaCarousel === 'undefined') return;
    if (!root) return;

    /* Collect EVERY layering slider under root, not just the first — the page has
       one per layer (base/mid/shell), so a single querySelector left the others
       uninitialised (no drag/free-scroll). */
    var containers;
    if (root.id && root.id.indexOf('layering-slider-') === 0) {
      containers = Array.prototype.slice.call(root.querySelectorAll('.carousel-banner__swiper-container.embla'));
    } else {
      containers = Array.prototype.slice.call(root.querySelectorAll('[id^="layering-slider-"] .carousel-banner__swiper-container.embla'));
    }

    if (!containers.length) return;

    containers.forEach(function (container) {
      /* Double-init guard */
      if (container.getAttribute(INIT_ATTR) === 'true') return;
      container.setAttribute(INIT_ATTR, 'true');

      var scope    = container.closest('.carousel-banner__container') || container.closest('[id^="layering-slider-"]') || container;
      var viewport = container.querySelector('.embla__viewport');
      if (!viewport) return;

      var slides       = Array.prototype.slice.call(container.querySelectorAll('.embla__slide'));
      var arrowsWrap   = scope.querySelector('.carousel-banner__arrow');
      var prevEl       = scope.querySelector('.swiper-button-prev');
      var nextEl       = scope.querySelector('.swiper-button-next');
      var controlsSetting = parseBoolean(container.dataset.emblaControls);
      var loopSetting     = parseBoolean(container.dataset.emblaLoop);
      var dragFreeSetting = parseBoolean(container.dataset.emblaDragFree);

      /* Arrow visibility */
      if (controlsSetting === false && arrowsWrap) {
        arrowsWrap.style.display = 'none';
        prevEl = null;
        nextEl = null;
      } else if (arrowsWrap) {
        arrowsWrap.style.display = '';
      }

      var perView      = applySlideSizing(container, slides);
      var shouldLoop   = loopSetting === null
        ? (perView ? slides.length > perView : slides.length > 4)
        : loopSetting;
      var shouldDragFree = dragFreeSetting === null ? true : dragFreeSetting;

      var embla = window.EmblaCarousel(viewport, {
        align:         'start',
        loop:          shouldLoop,
        dragFree:      shouldDragFree,
        containScroll: shouldLoop ? false : 'trimSnaps',
        skipSnaps:     shouldDragFree
      });
      container._embla          = embla;
      container._emblaLoop      = shouldLoop;
      container._emblaDragFree  = shouldDragFree;
      container._emblaPerView   = perView;

      /* Once the user starts dragging, suppress the "settle" re-measures below: a
         reInit mid-swipe destroys/recreates the engine and kills the in-flight drag
         momentum, which reads as stutter. */
      container._emblaEngaged = false;
      if (typeof embla.on === 'function') {
        embla.on('pointerDown', function () { container._emblaEngaged = true; });
      }

      function settleReInit() {
        if (container._emblaEngaged) return;
        if (container._embla && typeof container._embla.reInit === 'function') {
          try { container._embla.reInit(); } catch (e) { /* no-op */ }
        }
      }

      /* One-off re-measure after the initial layout settles. We deliberately do NOT
         reInit on every image load: slide WIDTHS are CSS-driven (flex-basis), so an
         image finishing only changes height, never the horizontal measurement — and a
         reInit per image while swiping was a direct cause of the scroll stutter. */
      if (!container._emblaInitialReinitQueued) {
        container._emblaInitialReinitQueued = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(settleReInit);
        });
        window.addEventListener('load', settleReInit);
      }

      /* Arrow click handlers */
      if (prevEl) {
        prevEl.onclick = function () { if (container._embla) container._embla.scrollPrev(); };
      }
      if (nextEl) {
        nextEl.onclick = function () { if (container._embla) container._embla.scrollNext(); };
      }

      /* Resize handler (debounced, 150 ms to match PDP) */
      if (!container._emblaResizeBound) {
        container._emblaResizeBound = true;
        var resizeTimer;
        var lastWidth = window.innerWidth;
        window.addEventListener('resize', function () {
          /* Width drives the horizontal layout; height does not. On mobile the
             browser fires 'resize' as the address bar shows/hides during scroll —
             reacting to that would reInit (and stutter) mid-swipe, so ignore
             height-only changes. */
          if (window.innerWidth === lastWidth) return;
          lastWidth = window.innerWidth;
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            var nextPerView   = applySlideSizing(container, slides);
            var nextLoop      = loopSetting === null
              ? (nextPerView ? slides.length > nextPerView : slides.length > 4)
              : loopSetting;
            var nextDragFree  = dragFreeSetting === null ? true : dragFreeSetting;

            if (container._embla && (
              container._emblaLoop !== nextLoop ||
              container._emblaDragFree !== nextDragFree
            )) {
              try { if (typeof container._embla.destroy === 'function') container._embla.destroy(); } catch (e) { /* no-op */ }
              container._embla = window.EmblaCarousel(viewport, {
                align:         'start',
                loop:          nextLoop,
                dragFree:      nextDragFree,
                containScroll: nextLoop ? false : 'trimSnaps',
                skipSnaps:     nextDragFree
              });
              container._emblaLoop     = nextLoop;
              container._emblaDragFree = nextDragFree;
              container._emblaPerView  = nextPerView;
            } else if (container._embla && typeof container._embla.reInit === 'function') {
              container._embla.reInit();
              container._emblaLoop     = nextLoop;
              container._emblaDragFree = nextDragFree;
              container._emblaPerView  = nextPerView;
            }
          }, 150);
        });
      }
    });
  }

  function destroySection(root) {
    if (!root) return;
    var sectionEl = root.id && root.id.indexOf('layering-slider-') === 0
      ? root
      : root.querySelector('[id^="layering-slider-"]');
    if (!sectionEl) return;
    var containers = Array.prototype.slice.call(
      sectionEl.querySelectorAll('.carousel-banner__swiper-container.embla')
    );
    containers.forEach(function (container) {
      if (container._embla && typeof container._embla.destroy === 'function') {
        try { container._embla.destroy(); } catch (e) { /* no-op */ }
        container._embla = null;
      }
      container.removeAttribute(INIT_ATTR);
      container._emblaInitialReinitQueued = false;
      container._emblaResizeBound         = false;
    });
  }

  /* Boot — wait for the Embla library before initialising. Embla is a deferred
     external (CDN) script, so on slower mobile connections it can load AFTER
     DOMContentLoaded; without this retry the carousel silently never inits and
     can't be dragged/swiped. Retries ~10s, then a final window.load backstop.
     The per-container INIT_ATTR guard makes repeat calls safe. */
  var bootTries = 0;
  function boot() {
    if (typeof window.EmblaCarousel === 'undefined') {
      if (bootTries++ < 100) { setTimeout(boot, 100); }
      return;
    }
    initSection(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  /* Theme editor lifecycle */
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) initSection(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e && e.target) initSection(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e && e.target) destroySection(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
